import md5 from 'blueimp-md5';

export const GravatarFilterModule = angular
    .module('app.filters.gravatarFilter', [])
    .filter('gravatar', () => {
        return (s) => {
            if (!s) return null;
            return md5(s.toString().trim().toLowerCase());
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/filters/gravatar.filter.js